import { checkbox } from 'vue-strap'

// Retain v-model/group behavior. Native semantics preserve links in terms labels.
export default {
    extends: checkbox,
    render (h) {
        return h('label', {
            class: ['open checkbox', this.typeColor, { active: this.checked, disabled: this.disabled, readonly: this.readonly }]
        }, [
            h('input', {
                class: 'tone-native-checkbox',
                attrs: {
                    type: 'checkbox',
                    name: this.name,
                    disabled: this.disabled,
                    'aria-readonly': this.readonly ? 'true' : 'false'
                },
                domProps: { checked: !!this.checked },
                on: {
                    change: event => {
                        if (this.disabled || this.readonly) event.target.checked = !!this.checked
                        else this.checked = event.target.checked
                    }
                }
            }),
            this.$slots.default
        ])
    }
}



// WEBPACK FOOTER //
// ./src/accessibility/Checkbox.js